export default __webpack_public_path__ + "static/media/404.b6b4fed3.png";